module.exports = __webpack_public_path__ + "static/media/011.382d2175.jpg";